import { RESET_STATE } from 'store/global/actions';

import { USER_PROPERTIES_ACTIONS } from '../actions';

const initialState = {
  propertyDefinitions: [],
  userOverrides: [],
};

const userPropertiesReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case USER_PROPERTIES_ACTIONS.GET_PROPERTY_DEFINITIONS:
      return { ...state, propertyDefinitions: payload || [] };

    case USER_PROPERTIES_ACTIONS.GET_USER_OVERRIDES:
      return { ...state, userOverrides: payload || [] };

    case USER_PROPERTIES_ACTIONS.SET_USER_OVERRIDE: {
      const { propertyName } = meta;
      const existingIndex = state.userOverrides.findIndex(
        o => o.propertyKey === propertyName || o.propertyName === propertyName,
      );
      const updatedOverride = payload || { propertyKey: propertyName, value: meta.value };

      if (existingIndex !== -1) {
        return {
          ...state,
          userOverrides: state.userOverrides.map((item, index) =>
            index === existingIndex ? updatedOverride : item,
          ),
        };
      }

      return { ...state, userOverrides: [...state.userOverrides, updatedOverride] };
    }

    case USER_PROPERTIES_ACTIONS.DELETE_USER_OVERRIDE:
      return {
        ...state,
        userOverrides: state.userOverrides.filter(
          o => o.propertyKey !== meta.propertyName && o.propertyName !== meta.propertyName,
        ),
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default userPropertiesReducer;
